/**
 * ProgressRing — small, dependency-free SVG progress ring.
 *
 * <ProgressRing value={68} size={72} strokeWidth={7} label="68%" accent="#1E3355" />
 */
export function ProgressRing({
    value = 0,
    size = 72,
    strokeWidth = 7,
    accent = "#1E3355",
    trackColor = "#E5E7EB",
    label,
    sublabel,
    className = "",
    testid,
}) {
    const clamped = Math.max(0, Math.min(100, value));
    const r = (size - strokeWidth) / 2;
    const c = 2 * Math.PI * r;
    const offset = c - (clamped / 100) * c;
    const center = size / 2;
    return (
        <div className={`relative inline-flex items-center justify-center ${className}`} style={{ width: size, height: size }} data-testid={testid}>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
                <circle cx={center} cy={center} r={r} stroke={trackColor} strokeWidth={strokeWidth} fill="none" />
                <circle
                    cx={center}
                    cy={center}
                    r={r}
                    stroke={accent}
                    strokeWidth={strokeWidth}
                    fill="none"
                    strokeLinecap="round"
                    strokeDasharray={c}
                    strokeDashoffset={offset}
                    style={{ transition: "stroke-dashoffset 500ms cubic-bezier(0.22, 1, 0.36, 1)" }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center leading-tight">
                {label !== undefined && (
                    <span className="font-display font-bold text-[#1E3355]" style={{ fontSize: Math.max(11, size * 0.22) }}>
                        {label}
                    </span>
                )}
                {sublabel !== undefined && (
                    <span className="text-[9px] uppercase tracking-widest text-gray-500 mt-0.5">{sublabel}</span>
                )}
            </div>
        </div>
    );
}

export default ProgressRing;
